"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonDefaults = void 0;
exports.sideDefaults = sideDefaults;
exports.defaults = defaults;
exports.keepCommonOnly = keepCommonOnly;
const property_1 = require("@genesys/property");
/**
 * The values a coil starts out with, split the way the definitions are.
 *
 * Everything a coil has regardless of what runs through it. Switching coil type keeps these,
 * so the geometry someone has typed survives the switch.
 */
const common = [
    "coilstaggered=0",
    "coilrows=4",
    "coildistbtwrows=26:Millimeter",
    "coiltubesinheight=10:One",
    "coiltubelength=1000:Millimeter",
    "coildistbtwtubes=30:Millimeter",
    "coilcircuitsorpasses=1",
    "coilcircuits=4:One",
    "coilpasses=10:One",
    "coilfinspacingorfinsperlength=1",
    "coilfinspacing=2.5:Millimeter",
    "coilfinsperinch=10.1599999949:One",
    "coilconnectionside=1",
    "coilexchangerflowtype=1",
    "tubesmaterial=1",
    "tubesconductivity=330:WattPerMeterPerKelvin",
    "tubesthickness=0.4:Millimeter",
    "tubesexternaldiameter=12.45:Millimeter",
    "tubesfouling=0:One",
    "finsconductivity=330:WattPerMeterPerKelvin",
    "finsthickness=0.12:Millimeter",
    "finsfouling=0:One",
    "inletcollectornrofcollectors=1",
    "inletcollectorthickness=1:Millimeter",
    "inletcollectordiameter=28:Millimeter",
    "inletcollectormaterialtype=1",
    "outletcollectornrofcollectors=1",
    "outletcollectorthickness=1:Millimeter",
    "outletcollectordiameter=28:Millimeter",
    "outletcollectormaterialtype=1",
    "airinputstemperature=32:Celsius",
    "airinputshumidity=50:PercentHumidity",
    "airinputspressure=1.013:Bar",
    "airinputsairflow=1500:StandardCubicMeterPerHour",
    "coefficientsadry=0.1:One",
    "coefficientsbdry=-0.28:One",
    "coefficientscdry=1.78:One",
    "coefficientsddry=2.9:One",
    "coefficientsawet=0.094:One",
    "coefficientsbwet=-0.32:One",
    "coefficientscwet=1.8:One",
    "coefficientsdwet=3.2:One",
    "calculationmethod=0",
    "calculationmethodtargettemperature=22:Celsius",
    "safetyonsurface=0:One",
    "safetyoncapacity=0:One"
];
const fluid = [
    // Headers exist only on a fluid coil; every other coil type sends CoilPro none.
    "inletheadernrofheaders=1",
    "inletheaderthickness=1:Millimeter",
    "inletheaderdiameter=28:Millimeter",
    "inletheadermaterialtype=1",
    "outletheadernrofheaders=1",
    "outletheaderthickness=1:Millimeter",
    "outletheaderdiameter=28:Millimeter",
    "outletheadermaterialtype=1",
    "temperaturein=7:Celsius",
    "temperatureflow=0",
    "temperatureout=14:Celsius",
    "temperatureoutmin=10:Celsius",
    "temperatureoutmax=20:Celsius",
    "temperatureoutstep=2:Celsius",
    "flow=0:LiterPerHour",
    "flowmin=100:LiterPerHour",
    "flowmax=2000:LiterPerHour",
    "flowstep=200:LiterPerHour",
    "antifreeze=0",
    "concentrationtype=0",
    "concentration=30:Percent",
    // Start-up values are exactly what the server used to hardcode, so a modulation behaves as
    // it always did until someone narrows the box.
    "constraintsminvelocity=0:MeterPerSecond",
    "constraintsmaxvelocity=10:MeterPerSecond",
    "constraintsmaxflow=150000:LiterPerHour",
    "constraintsmaxpressuredrop=200:KiloPascal"
];
const dx = [
    "evaporationtemp=8:Celsius",
    "condensationtemp=50:Celsius",
    "subcoolingtemp=0:DeltaCelsius",
    "superheattemp=0:DeltaCelsius",
    "freon=4"
];
const steam = [
    "pressure=5:Bar",
    "pressuremin=4:Bar",
    "pressuremax=6:Bar",
    "pressurestep=0.5:Bar",
    // A steam coil subcools condensate, which is not what a refrigerant coil subcools, so the
    // two carry their own values as well as their own labels.
    "subcoolingtemp=0:DeltaCelsius",
    "superheattemp=0:DeltaCelsius",
    "stepproperty=0",
    "airinputstemperaturemin=30:Celsius",
    "airinputstemperaturemax=36:Celsius",
    "airinputstemperaturestep=2:Celsius",
    "airinputshumiditymin=50:PercentHumidity",
    "airinputshumiditymax=55:PercentHumidity",
    "airinputshumiditystep=1:PercentHumidity"
];
const bySide = {
    fluid: fluid,
    // DX and condenser take the same refrigerant side.
    dx: dx,
    condenser: dx,
    steam: steam
};
function toPvs(entries) {
    return entries.reduce((soFar, next) => property_1.PropertyValueSet.merge(soFar, property_1.PropertyValueSet.fromString(next)), property_1.PropertyValueSet.Empty);
}
exports.commonDefaults = toPvs(common);
function sideDefaults(coilType) {
    return toPvs(bySide[coilType]);
}
function defaults(coilType) {
    return property_1.PropertyValueSet.merge(exports.commonDefaults, sideDefaults(coilType));
}
/**
 * What survives a change of coil type: the coil itself, the air, the coefficients. A property
 * name says nothing about which side it belongs to, so the list above is what decides - the
 * two derived dimensions included, since they are recomputed anyway.
 */
const commonNames = [
    ...common.map(entry => entry.split("=", 1)[0]),
    "coilheight",
    "coilwidth"
];
function keepCommonOnly(pvs) {
    return property_1.PropertyValueSet.keepProperties(commonNames, pvs);
}
//# sourceMappingURL=initial-values.js.map